import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

import Select from '../common/Select';
import AdditionalEventOptions from './AdditionalEventOptions';

const StyledEventsItemContainer = styled.div`
  border: 1px solid #999999;
  width: calc(100% - 20px);
  padding: 10px;
  margin: 10px;

  .full-width-container {
    width: 100%;
  }

  .row-flex {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .select-container {
    display: flex;
    align-items: center;
  }

  .unique-char {
    font-weight: bold;
    margin-right: 10px;
  }

  .button-container {
    display: flex;
    align-items: center;
  }
`;

const StyledSelect = styled(Select)`
  width: 250px;

  .ant-select-selection-item {
    font-weight: bold;
  }
`;

const StyledDynamicButton = styled(({ isVisible, ...props }) => <Button {...props} />)`
  border: none;
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
`;

const EventsItem = (props) => {
  const {
    id,
    uniqueChar,
    event,
    events,
    multipleEvents,
    onChangeEvent,
    onDuplicateEvent,
    visible,
    onClose,
    children,
    getEventMetainf,
  } = props;

  return (
    <StyledEventsItemContainer className="custom-events-item" key={id}>
      <div className="full-width-container">
        <div className="row-flex">
          <div className="select-container">
            <div className="unique-char">{uniqueChar}.</div>
            <StyledSelect
              className="ant-select-border-bottom"
              value={event || undefined}
              values={[...events].sort((a, b) => a.localeCompare(b))}
              onChange={(e) => {
                onChangeEvent(e, getEventMetainf(e));
              }}
              placeholder="Select an event"
            />
          </div>
          <div className="button-container">
            <AdditionalEventOptions onDuplicateEvent={onDuplicateEvent} id={id} />
            <StyledDynamicButton
              icon={<CloseOutlined />}
              isVisible={multipleEvents}
              onClick={onClose}
            />
          </div>
        </div>
        {visible && children}
      </div>
    </StyledEventsItemContainer>
  );
};

export default EventsItem;
